<template>
  <div class="content" v-if="$auth.ready()">
    <div class="columns is-centered is-gapless" style="margin-top: 3rem;">
      <div class="column is-4">
        <div class="box">
          <h2 class="is-title is-bold has-text-centered has-text-primary">
            Let's Talk
          </h2>
          <hr></hr>
          <div v-show="error" style="color:red; word-wrap:break-word;">{{ error }}</div>
          <form>
            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input name="Name" class="input" v-model="contactInfo.name" type="text" placeholder="Your Name" required>
                <span class="icon is-small is-left">
                  <i class="fa fa-user"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input name="Email" class="input" type="email" v-model="contactInfo.email" placeholder="Your Email" required>
                <span class="icon is-small is-left">
                    <i class="fa fa-envelope"></i>
                </span>
                <span class="icon is-small is-right" style="display:none">
                    <i class="fa fa-check"></i>
                </span>
                <span class="icon is-small is-right" style="display:none">
                    <i class="fa fa-warning"></i>
                </span>
              </div>
              <p class="help is-danger" id="email-invalid" style="display:none">This email is invalid</p>
            </div>
            
            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input class="input" type="text" v-model="contactInfo.phoneNumber" placeholder="Your Phone Number" required>
                <span class="icon is-small is-left">
                    <i class="fa fa-phone-square"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <div class="control has-icon dateInput">
                <datetime v-model="contactInfo.time" :min-datetime="new Date().toISOString()" :use12-hour="true" type="datetime" 
                  :minute-step="15" :auto="true" 
                  :format="{ year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: '2-digit', timeZoneName: 'short' }" :placeholder="datePlaceholder">
                </datetime>
                <span class="icon is-small">
                  <i class="fa fa-calendar"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <div class="control">
                <textarea name="Message" class="textarea" v-model="contactInfo.details" placeholder="Tell us what's on your mind..." required></textarea>
              </div>
            </div>
            
            <p class="control has-text-centered" style="margin-top: 1rem;">
              <button id="submit2" class="button is-primary" :disabled="submitOnProcess" v-on:click="submitContactForm()">&nbsp;Send</button>
            </p>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from 'axios'
import * as globalConstants from '../../globalConstants.js'
import {Datetime} from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
export default {
  components: {
    datetime: Datetime
  },
  data () {
    return {
      datePlaceholder: 'Set time',
      error: '',
      submitOnProcess: false,
      contactInfo: {
        name: '',
        email: '',
        phoneNumber: '',
        time: '',
        details: ''
      }
    }
  },
  methods: {
    submitContactForm () {
      this.submitOnProcess = true
      axios.post(globalConstants.apiURL + '/api/v1/submitContactForm', this.contactInfo)
      .then(response => {
        this.submitOnProcess = false
        this.contactInfo = {
          name: '',
          email: '',
          phoneNumber: '',
          time: '',
          details: ''
        }
      })
      .catch(error => {
        console.log(error)
      })
    }
  }
}
</script>

<style lang="scss">
.dateInput {
  .vdatetime-input {
    padding-left: 2.25em;
    -moz-appearance: none;
    -webkit-appearance: none;
    -ms-flex-align: center;
    align-items: center;
    border: 1px solid transparent;
    border-radius: 3px;
    box-shadow: none;
    display: -ms-inline-flexbox;
    display: inline-flex;
    font-size: 1rem;
    height: 2.25em;
    -ms-flex-pack: start;
    justify-content: flex-start;
    line-height: 1.5;
    padding-bottom: calc(0.375em - 1px);
    padding-right: calc(0.625em - 1px);
    padding-top: calc(0.375em - 1px);
    position: relative;
    vertical-align: top;
    background-color: #fff;
    border-color: #dbdbdb;
    color: #363636;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    max-width: 100%;
    width: 100%;
  }
}  
</style>



// WEBPACK FOOTER //
// ContactUs.vue?2f7ab073